// Shared right rail (Caesar advisory + Caesar lock + ledger), ported from
// approved-cockpit.js rightRail(). The advisory note is per-page.
// Advisory notes are GENERIC and honest per page — no fabricated ticker-specific
// claims (e.g. "AAPL is above VWAP", "72% confidence"). Caesar describes what he
// does on each page; the real numbers live in the page's own analysis panels.
export const RAIL_NOTES: Record<string, string> = {
  home: 'Advisory only — analyzes, explains, and prepares Owner-Only actions.',
  options: 'I read the pricing, greeks, and probability the page computes, and explain the trade-offs. Owner judgment required.',
  daytrade: 'I read your entry, stop, and target against the risk controls, and explain what the numbers imply. Owner judgment required.',
  commodities: 'I read the fair value, carry, and scenarios the page computes, and explain what they mean. Owner judgment required.',
  futures: 'I compare contract specs, strategy context, and hedge scenarios. Education and paper only.',
  forex: 'I read your position sizing and reward-to-risk, and explain the trade-offs. Owner judgment required.',
  crypto: 'I analyze, explain, and sort data. I do not execute trades.',
  dashboard: 'I sort events by clarity, context, and conviction.',
  portfolio: 'I compare forecasts against outcomes and keep the paper ledger honest.',
};

export function RightRail({ kind = 'home' }: { kind?: string }) {
  const note = RAIL_NOTES[kind] || 'Advisory only — analyzes, explains, and prepares Owner-Only actions.';
  return (
    <aside class="om-right-rail">
      <section class="om-right-card om-glass">
        <div class="om-right-title">
          <h2>Caesar</h2>
          <img class="om-eye" src="/icons/eye-of-apathy.svg?v=6" alt="" />
        </div>
        <p class="om-good">Advisory Only</p>
        <p>{note}</p>
        <a class="om-btn cyan" href="/caesar">Ask Caesar</a>
      </section>
      <section class="om-right-card om-glass">
        <div class="om-right-title">
          <h2>Caesar Lock</h2>
          <strong class="om-good">ENGAGED</strong>
        </div>
        <p>Advisory only — Caesar reviews and locks execution behind Owner-Only approval. Live execution remains Pending Owner until explicitly armed.</p>
        <div class="om-kv">
          <div><span>Max Daily Loss</span><strong class="om-good">$0</strong></div>
          <div><span>Max Position Risk</span><strong class="om-good">1.00%</strong></div>
          <div><span>Max Open Forecasts</span><strong class="om-good">100</strong></div>
        </div>
      </section>
      <section class="om-right-card om-glass">
        <div class="om-right-title"><h2>DataHub Ledger</h2></div>
        <p>All quotes, inputs, forecasts, and results are timestamped for audit and review.</p>
        <a class="om-btn" href="/portfolio">View Ledger</a>
      </section>
    </aside>
  );
}
